import { styled as r, Link as z, Box as h, SwipeableDrawer as A } from "@mui/material";
import w from "../../components/share/next/Image.js";
import E from "../button/ImageButton.js";
import { noForwardCustomProps as P } from "../../util/styled/index.js";
import { useState as u, useEffect as D } from "react";
import { jsxs as p, jsx as s, Fragment as H } from "react/jsx-runtime";
const N = r(w)`
  position: absolute;
  z-index: 2;
  bottom: 25%;
  width: 4.5vw;
  height: 4px;
  @media only screen and (max-width: 1279px) {
    bottom: auto;
    position: absolute;
    margin-top: 8%;
    width: 100%;
    height: 5px;
    object-fit: cover;
    display: inline;
  }
  @media only screen and (max-width: 767px) {
    bottom: auto;
    width: 100%;
    margin-top: 1.5rem;
    height: 2px;
  }
`, M = r(w)`
  display: none;
  z-index: 2;
  position: absolute;
  @media only screen and (max-width: 1279px) {
    bottom: auto;
    position: absolute;
    margin-top: 8%;
    width: 100%;
    height: 5px;
    object-fit: cover;
    display: inline;
  }
  @media only screen and (max-width: 767px) {
    width: 100%;
    bottom: auto;
    margin-top: 1.5rem;
    height: 2px;
  }
`, L = r(z, P(["isActive", "styles"]))`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
  ${(t) => t.styles ? t.styles : t.isActive ? `
          font-style: normal;
          font-weight: 400;
          font-size: clamp(12px, 1.1vw, 14px);
          display: flex;
          color: #f5f5f5;
          border-radius: unset;
          background-color: transparent;
          cursor: pointer;
          padding: 25px clamp(15px, 1.6vw, 25px);
          display: flex;
          justify-content: center;
          align-items: center;
          @media only screen and (max-width: 1279px) {
            padding: 29px 42px;
            font-style: bold;
            font-weight: 700;
            font-size: 32px;
            justify-content: start;
          }
          @media only screen and (max-width: 767px) {
            padding: 18px 26px;
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
          }
        ` : `
          font-style: normal;
          font-weight: 400;
          font-size: clamp(12px, 1.1vw, 14px);
          display: flex;
          color: rgba(245, 245, 245, 0.7);
          border-radius: unset;
          background-color: transparent;
          cursor: pointer;
          justify-content: center;
          align-items: center;
          padding: 25px clamp(15px, 1.6vw, 25px);
          &:hover {
            color: #f5f5f5;
          }
    
          @media only screen and (max-width: 1279px) {
            padding: 29px 42px;
            font-style: normal;
            font-weight: 400;
            font-size: 32px;
            justify-content: start;
          }
          @media only screen and (max-width: 767px) {
            padding: 18px 26px;
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
          }
        `}
`, O = r(h)`
  background: rgba(0, 0, 0, 0);
  z-index: 5;
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: flex-end;
  @media only screen and (max-width: 1279px) {
    display: none;
  }
`, R = r(h)`
  background: rgba(0, 0, 0, 0);
  z-index: 5;
  width: 100%;
  height: 100%;
  justify-content: right;
  display: none;
  @media only screen and (max-width: 1279px) {
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    align-items: center;
  }
`, S = r(h)`
  margin-right: 24px;
  width: 48px;
  height: 48px;
`, I = r(A)`
  display: none;
  > .MuiDrawer-paper {
    max-width: 100%;
    height: 100%;
    overflow-x: hidden;
    scroll-behavior: smooth;
    background-color: #0d1015;
    box-sizing: border-box;
  }
  @media only screen and (max-width: 1279px) {
    > .MuiDrawer-paper {
      width: 50vw;
    }
    display: flex;
    max-width: 100%;
    overflow-x: hidden;
    scroll-behavior: smooth;
  }
  @media only screen and (max-width: 767px) {
    > .MuiDrawer-paper {
      width: 70vw;
    }
  }
`, J = ({
  navItems: t,
  highlight: y,
  borderline: b,
  menuIcon: v
}) => {
  const [k, B] = u(!1), x = Array.from(t, () => !1);
  x[1] = !0;
  const [f, C] = u(x), l = (e) => {
    B(e);
  }, j = (e, n, a = !1) => {
    if (a)
      window.open(n, "_blank");
    else
      try {
        const o = document.getElementById(n.substring(1));
        o && window.scrollTo({
          behavior: "smooth",
          top: o.getBoundingClientRect().top - document.body.getBoundingClientRect().top + 20
        });
      } catch (o) {
        console.error(o);
      }
    e.preventDefault();
  }, m = t.map((e, n) => {
    var a;
    return /* @__PURE__ */ p(L, {
      href: "#",
      isActive: !0,
      styles: (a = e.css) == null ? void 0 : a.styles,
      onClick: (o) => {
        l(!1), e.onClickEvent ? e.onClickEvent() : j(o, e.href, e.newWindow);
      },
      children: [!e.css && /* @__PURE__ */ s(M, {
        src: b
      }), f[n] && /* @__PURE__ */ s(N, {
        fill: !0,
        src: y
      }), e.label]
    }, e.label);
  });
  return D(() => {
    const e = () => {
      const n = [...f], a = window.document.body.offsetHeight;
      try {
        t.forEach((o, i) => {
          if (n[i] = !1, t[i].href && !t[i].newWindow) {
            const g = document.getElementById(t[i].href.substring(1));
            if ((g ? g.getBoundingClientRect().top : 0) > 0) return;
            let d, c = 0;
            if (t[Number(i) + 1] ? (d = document.getElementById(t[Number(i) + 1].href.substring(1)), c = d ? d.getBoundingClientRect().top : 0) : c = a, c < 0) return;
            n[i] = !0;
          }
        });
      } catch (o) {
        console.error(o);
      }
      C(n);
    };
    return window.addEventListener("scroll", e, {
      passive: !0
    }), () => {
      window.removeEventListener("scroll", e);
    };
  }, []), /* @__PURE__ */ p(H, {
    children: [/* @__PURE__ */ s(O, {
      children: m
    }), /* @__PURE__ */ p(R, {
      children: [/* @__PURE__ */ s(S, {
        children: /* @__PURE__ */ s(E, {
          image: `url(${v});`,
          onClick: () => {
            l(!0);
          }
        })
      }), /* @__PURE__ */ s(I, {
        variant: "temporary",
        anchor: "right",
        open: k,
        onOpen: () => {
          l(!0);
        },
        onClose: () => {
          l(!1);
        },
        ModalProps: {
          keepMounted: !0
          // Better open performance on mobile.
        },
        BackdropProps: {
          sx: {
            backgroundColor: "rgba(255, 255, 255, 0.25)"
          }
        },
        children: m
      })]
    })]
  });
};
export {
  J as default
};
//# sourceMappingURL=Nav.js.map
